import { Component, inject } from "@angular/core";
import { UpgradeNavigationService } from "@bitwarden/web-vault/app/services/subscription/upgrade-navigation.service";

@Component({
  selector: "app-premium-callout",
  templateUrl: "./premium-callout.component.html",
})
export class PremiumCalloutComponent {
  protected showCallout = true;
  protected upgradeNavigation = inject(UpgradeNavigationService);
  close() {
    this.showCallout = false;
  }
}
